<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <list-page
        :columns="columns"
        :headers="headers"
        :popupComponent="popupComponent"
        :basic-data="basicData"
        sort="id"
        :descending="true"
        title="Site List"
        icon="mdi-sitemap"
        addButtonText="Site"
        stateendpoint="site.sites"
        :actions="actions"
    />
  </div>
</template>
<script>
import ListPage from "../components/ListPage";
import SitePopup from "../components/popups/SitePopup";

export default {
  name: 'Sites',
  metaInfo: {
    title: 'zetrank.com',
    titleTemplate: 'Admin Dashboard - Sites | %s',
    meta: [
      { name: 'robots', content: 'noindex' },
      { name: 'googlebot', content: 'noindex' }
    ]
  },
  components: {ListPage, SitePopup},
  data() {
    return {
      headers: [
       /* {
          text: 'Ordering',
          value: 'site_order'
        },*/
        {
          text: 'ID',
          value: 'siteId'
        },
        {
          text: 'Site URL',
          value: 'siteUrl'
        },
        /*{
          text: 'DA',
          align: 'left',
          value: 'da'
        },
        {
          text: 'PA',
          align: 'left',
          value: 'pa'
        },
        {
          text: 'DR',
          align: 'left',
          value: 'dr'
        },
        {
          text: 'UR',
          align: 'left',
          value: 'ur'
        },
        {
          text: 'Traffic',
          value: 'traffic'
        },
        {
          text: 'Google',
          value: 'googleNews'
        },
        {
          text: 'Other',
          value: 'casino'
        },
        {
          text: 'Follow',
          value: 'follow'
        },*/
       /* {
          text: 'Price',
          align: 'right',
          value: 'price'
        },
        {
          text: 'Other Price',
          align: 'right',
          value: 'adultPrice'
        },*/
        {
          text: 'Price',
          align: 'right',
          value: 'resellerPrice'
        },
        {
          text: 'Other Price',
          align: 'right',
          value: 'resellerAdultPrice'
        },
        {
          text: 'Admin Price',
          align: 'right',
          value: 'adminPrice'
        },
        {
          text: 'Admin Other Price',
          align: 'right',
          value: 'adminOthersPrice'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          text: 'Is New?',
          value: 'isNew'
        },
        {
          text: '', value: 'actions', sortable: false
        }
      ],
      columns: [
        {value: 'siteUrl'},
        {value: 'da'},
        {value: 'pa'},
        {value: 'dr'},
        {value: 'ur'},
        {value: 'traffic'},
        {value: 'googleNews'},
        {value: 'casino'},
        {value: 'follow'},
        {value: 'price', type: 'currency'},
        {value: 'resellerPrice', type: 'currency'},
        {value: 'isActive'},
        {value: 'isNew'},
        {value: 'action'},
      ],
      actions: {
        load: 'loadSites',
        create: 'storeSite',
        update: 'updateSite',
        remove: 'destroySite',
        softDelete: 'siteSoftDeleteHandler',
        sorted: 'siteBulkUpdateHandler',
      },
      basicData: {
        pa: 0,
        da: 0,
        dr: 0,
        ur: 0,
        traffic: 0,
        price: 0,
        follow: true,
        resellerPrice: 0,
        resellerAdultPrice: 0,
        adultPrice: 0,
        adminPrice: 0,
        adminOthersPrice: 0,
        isActive: true,
        isNew: true,
        googleNews: true,
        casino: true,
        nicheCategories: []
      }
    }
  },
  computed: {
    popupComponent() {
      return SitePopup;
    }
  },
  mounted() {
    this.$store.dispatch('loadAllNicheCategories')
  }
}
</script>
